module.exports = __webpack_public_path__ + "img/title_bg.44fc34c3.png";